<!--商家中心-->
<template>
  <div class="mine-customer">
    <div>
      <div class="user-header">
        <div class="user-message">
          <div class="user-detail">
            <!--            <img class="user-img" :src="row.pic_url" alt="">-->
            <div class="user-detail-right">
              <div class="user-name">HI , {{ row.name }}</div>
              <div class="user-invite" @click="toBusinessList">
                <img src="../../../assets/images/weiyuanhui/icon-qiehuan.png" alt="">
                <span class="invite-num">[切换省市]</span>
              </div>
            </div>
            <div class="user-setting-box" @click="toBusinessSet">
              <img src="../../../assets/images/weiyuanhui/icon-seeting.png" alt="">
            </div>
          </div>
        </div>
        <div class="user-black flex-between"  @click="toWeiyuanhuiDetail">
          <div class="user-black-top">
            <div class="user-moneys">
              <div class="user-moneys-title">年度赛事(场)</div>
              <div>{{ row.sai_year_count }}</div>
            </div>
            <div class="user-moneys" @click="toWeiyuanhuiDetail">
              <div class="user-moneys-title">累计赛事(场)</div>
              <div>{{ row.sai_count }}</div>
            </div>
          </div>
          <div class="user-black-middle"></div>
          <div class="user-black-top">
            <div class="user-moneys" @click="toWeiyuanhuiDetail">
              <div class="user-moneys-title">年度培训(场)</div>
              <div>{{ row.huiyi_year_count }}</div>
            </div>
            <div class="user-moneys">
              <div class="user-moneys-title">累计培训(场)</div>
              <div>{{ row.huiyi_count }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="credit-box">
        <div class="credit-ul">
          <div class="credit-li">
            <span>{{ row.danwei_count }}</span>
            <div class="credit-text">单位数</div>
          </div>
          <div class="credit-li">
            <span>{{ row.club_count }}</span>
            <div class="credit-text">俱乐部</div>
          </div>
          <div class="credit-li">
            <span>{{ row.qcxj_count }}</span>
            <div class="credit-text">考级中心/点</div>
          </div>
        </div>
<!--        <div class="credit-all">-->
<!--          <div class="credit-all-left">-->
<!--            累计赛事<span class="order-num">{{ row.sai_count }}</span> 场-->
<!--          </div>-->
<!--          <div class="credit-all-right">-->
<!--            累计培训<span class="order-num">{{ row.huiyi_count }}</span> 场-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <!--      <div class="credit-box">-->
      <!--        <div class="credit-ul">-->
      <!--          <div class="credit-li">-->
      <!--            ¥ <span>{{row.last_month_expect_profit/100}}</span>-->
      <!--            <div class="credit-text">上月收益</div>-->
      <!--          </div>-->
      <!--          <div class="credit-li">-->
      <!--            ¥ <span>{{row.current_month_expect_profit/100}}</span>-->
      <!--            <div class="credit-text">本月收益</div>-->
      <!--          </div>-->
      <!--          <div class="credit-li">-->
      <!--            ¥ <span>{{row.today_expect_profit/100}}</span>-->
      <!--            <div class="credit-text">今日收益</div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="credit-all">-->
      <!--          <div class="credit-all-left">-->
      <!--            累计收益 <span class="money-sym">¥</span><span class="credit-all-money">{{row.total_expect_profit/100}}</span>-->
      <!--          </div>-->
      <!--          <div class="credit-all-right">-->
      <!--            累计订单<span class="order-num">{{row.total_order_count}}</span> 笔-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <div class="mini-nav">
      <ul>
        <li @click="toDetail('WyhExameCenterList')">
          <img src="../../../assets/images/weiyuanhui/icon-qicaixingji.png" alt="">
          <p>七彩星级</p>
        </li>
        <li @click="toDetail('WyhClubList')">
          <img src="../../../assets/images/weiyuanhui/icon-julebu.png" alt="">
          <p>俱乐部</p>
        </li>
        <li @click="toDetail('WyhDakejianList')">
          <img src="../../../assets/images/weiyuanhui/icon-dakejianshenbao.png" alt="">
          <p>大课间申报</p>
        </li>
        <li @click="toDetail('WyhSihaoList')">
          <img src="../../../assets/images/weiyuanhui/icon-sihaoyundongyaun.png" alt="">
          <p>四好运动员</p>
        </li>
        <li @click="toDetail('WyhHuiyiApplyList')">
          <img src="../../../assets/images/weiyuanhui/icon-huiyi.png" alt="">
          <p>会议</p>
        </li>
        <li @click="toDetail('WyhJiaolianList')">
          <img src="../../../assets/images/weiyuanhui/icon-jiaolianyuanguanli.png" alt="">
          <p>教练员管理</p>
        </li>
        <li @click="toDetail('WyhCaipanList')">
          <img src="../../../assets/images/weiyuanhui/icon-caipanyaunguanli.png" alt="">
          <p>裁判员管理</p>
        </li>
        <li @click="toDetail('WyhSaiApplyList')">
          <img src="../../../assets/images/weiyuanhui/icon-saishi.png" alt="">
          <p>赛事</p>
        </li>
        <li @click="toDetail('WyhOrderList')">
          <img src="../../../assets/images/weiyuanhui/icon-customerorder.png" alt="">
          <p>客户订单管理</p>
        </li>
        <li @click="toDetail('WyhConfigureList')">
          <img src="../../../assets/images/weiyuanhui/icon-sellrorder.png" alt="">
          <p>销售单管理</p>
        </li>
      </ul>
    </div>

    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
  </div>
</template>
<style src="../../../assets/style/weiyuanhui.css" scoped></style>
<style scoped>
.user-black {
  height: 1.2rem;
}

.business-setting-img img {
  width: 66px;
  position: fixed;
  right: 1.2rem;
  bottom: 3.5rem;
  z-index: 10;
}

.mine-customer {
  overflow: auto;
  height: 100%;
  background: #f8f8f8;
}

.user-setting-box {
  position: absolute;
  right: 0;
  top: 0;
}

.user-invite img {
  width: 12px;
  height: 12px;
}

.invite-num {
  font-size: 12px;
  color: #666;
  font-family: PingFangSC-Regular, PingFang SC;
}

.user-header {
  background: url('../../../assets/images/weiyuanhui/icon-bg.png') no-repeat;
  background-size: 7.5rem 2.8rem;
}

.two-back {
  background: #73b7d0;
}
</style>

<script>
// import BusinessNavDialog from '@/components/business/BusinessNavDialog.vue';
import LoginDialog from '@/components/LoginDialog.vue';
import {Toast} from "vant";

export default {
  name: 'WeiyuanhuiIndex',
  components: {
    // BusinessNavDialog
    LoginDialog
  },
  data: function () {
    return {
      row: [],
      id: 0,
      navShow: false,
      loginShow: false,
    }
  },
  filter: {},
  mounted() {
    document.title = "省市中心"
    let weiyuanhui_id = this.id = this.$route.query.weiyuanhui_id
    if (weiyuanhui_id) {
      localStorage.setItem('_business_id', weiyuanhui_id)
    } else {
    }
    this.getWyhDetail();
  },
  destroyed() {
  },
  methods: {
    toDetail(name) {
      // this.$router.push({name: name})
      rbLink({name: name})
    },

    getWyhDetail() {
      let that = this;
      that.$api.get('/wyhadminapi/weiyuanhui/wyhDetail', {id: that.id}, (res) => {
        that.row = res.data
      }, (res) => {
        if (res.code == 401 || res.code == 402) {
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      })
    },

    toBusinessList() {
      let that = this;
      rbLink({
        name: 'WeiyuanhuiList'
      }, 'replace')
      // that.$router.replace({
      //     name: 'WeiyuanhuiList'
      // })
    },

    toBusinessSet() {
      let that = this;
      rbLink({
        name: 'SiteSettingIndex'
      })
      // that.$router.push({
      //     name: 'SiteSettingIndex'
      // })
    },

    toWeiyuanhuiDetail() {
      let that = this;
      rbLink({
        name: 'WeiyuanhuiDetail'
      })
    },
    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.getWyhDetail()
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },
  }
}
</script>



// WEBPACK FOOTER //
// WeiyuanhuiIndex.vue?74065c8e